<template>
  <div class="body-container">
    <div class="body-box">
      <div class="search">
        <input
          type="text"
          placeholder="请输入职位或企业名称"
          v-model="queryParams.seacherButton"
        />
        <button @click="getRecruitNoticeList()">搜索</button>
      </div>
      <div class="chooes-box">
        <!-- 薪资 -->
        <div class="xz-box">
          <div class="xz-item">薪资</div>
          <div
            class="xz-item"
            :class="{ active: currentIndex == 0 }"
            @click="
              handlerIndex(0);
              queryParams.compensation = '全部';
              getRecruitNoticeList();
            "
          >
            全部
          </div>
          <div
            class="xz-item"
            :class="{ active: currentIndex == 1 }"
            @click="
              handlerIndex(1);
              queryParams.compensation = '5K以下';
              getRecruitNoticeList();
            "
          >
            5K以下
          </div>
          <div
            class="xz-item"
            :class="{ active: currentIndex == 2 }"
            @click="
              handlerIndex(2);
              queryParams.compensation = '5K-10K';
              getRecruitNoticeList();
            "
          >
            5K-10K
          </div>
          <div
            class="xz-item"
            :class="{ active: currentIndex == 3 }"
            @click="
              handlerIndex(3);
              queryParams.compensation = '10K-20K';
              getRecruitNoticeList();
            "
          >
            10K-20K
          </div>
          <div
            class="xz-item"
            :class="{ active: currentIndex == 4 }"
            @click="
              handlerIndex(4);
              queryParams.compensation = '20K-40K';
              getRecruitNoticeList();
            "
          >
            20K-40K
          </div>
          <div
            class="xz-item"
            :class="{ active: currentIndex == 5 }"
            @click="
              handlerIndex(5);
              queryParams.compensation = '40K-60K';
              getRecruitNoticeList();
            "
          >
            40K-60K
          </div>
          <div
            class="xz-item"
            :class="{ active: currentIndex == 6 }"
            @click="
              handlerIndex(6);
              queryParams.compensation = '60K以上';
              getRecruitNoticeList();
            "
          >
            60K以上
          </div>
        </div>

        <!-- 更多 -->
        <div class="xz-box">
          <div class="xz-item">更多</div>
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 0 }"
            @click="handlergd(0)"
          >
            <el-select
              v-model="queryParams.userSignup"
              placeholder="请选择是否开启报名"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="item in userSignup"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </div>
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 1 }"
            @click="handlergd(1)"
          >
            <el-select
              v-model="queryParams.nature"
              placeholder="请选择性质"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="dict in reNature"
                :key="dict.dictSort"
                :label="dict.dictLabel"
                :value="dict.dictSort"
              />
            </el-select>
          </div>
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 2 }"
            @click="handlergd(2)"
          >
            <el-select
              v-model="queryParams.experience"
              placeholder="请选择经验"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="dict in reExperience"
                :key="dict"
                :label="dict"
                :value="dict"
              />
            </el-select>
          </div>
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 3 }"
            @click="handlergd(3)"
          >
            <el-select
              v-model="queryParams.degree"
              placeholder="请选择学历"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="dict in recruitEducation"
                :key="dict"
                :label="dict"
                :value="dict"
              />
            </el-select>
          </div>
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 5 }"
            @click="handlergd(5)"
          >
            <el-select
              v-model="queryParams.scale"
              placeholder="请选择单位规模"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="dict in reScale"
                :key="dict"
                :label="dict"
                :value="dict"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="xz-box">
          <div class="xz-item"></div>
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 6 }"
            @click="handlergd(6)"
          >
            <el-select
              v-model="queryParams.financing"
              placeholder="请选择融资阶段"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="dict in reFinancing"
                :key="dict"
                :label="dict"
                :value="dict"
              ></el-option>
            </el-select>
          </div>
          <!-- 123 -->
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 7 }"
            @click="handlergd(7)"
          >
            <el-select
              v-model="queryParams.territory"
              placeholder="请选择行业领域"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="territory in categoryIs"
                :key="territory"
                :label="territory"
                :value="territory"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="more-item"
            :class="{ active: currentIndexgd == 8 }"
            @click="handlergd(8)"
          >
            <el-select
              v-model="queryParams.positionCategory"
              placeholder="请选择职位类别"
              clearable
              @change="getRecruitNoticeList()"
            >
              <el-option
                v-for="poatname in postNameIs"
                :key="poatname"
                :label="poatname"
                :value="poatname"
              >
              </el-option>
            </el-select>
          </div>
          <div :class="{ active: currentIndexgd == 9 }" @click="handlergd(9)">
            <el-date-picker
              @change="getRecruitNoticeList()"
              style="width: 310px"
              v-model="signTime"
              type="datetimerange"
              align="right"
              unlink-panels
              range-separator="——"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-res">
        <div class="left-box" v-if="recruitNoticeList.length > 0">
          <div
            class="res-item"
            v-for="(item, index) in recruitNoticeList"
            :key="index"
          >
            <div class="top-res">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="date">发布时间: {{ item.publishTime }}</div>
            </div>
            <div class="top-res">
              <div class="type">
                当前阶段: {{ item.statusName }} | 招聘岗位:
                <span> {{ item.postNum }}</span> | 招聘人数:
                <span> {{ item.totalNumber }}</span>
              </div>
              <div
                :class="item.status == 2 ? 'button-over' : 'button'"
                @click="goTo(item.id, item.status)"
              >
                {{
                  item.sendResume == 1 && item.status == 1
                    ? "简历投递中"
                    : item.statusName
                }}
              </div>
            </div>
          </div>

          <div class="pages" v-if="total > 0">
            <el-pagination
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next, jumper"
              :total="total"
              :page-size="8"
              :current-page.sync="pageNum"
            >
            </el-pagination>
          </div>
        </div>
        <div v-else style="width: 100%">
          <el-divider content-position="center">暂无数据</el-divider>
          <!-- <div class="no-list">暂无数据</div> -->
        </div>
        <div class="right-box">
          <img
            v-for="(item, index) in middleImageList"
            :key="index"
            :src="item.advUrl"
            @click="goDetail(item)"
          />
          <!-- <img src="../../assets/newImg/gg1.png" alt="" />
                    <img src="../../assets/newImg/gg2.png" alt="" />
                    <img src="../../assets/newImg/gg2.png" alt="" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { re } from "semver";
export default {
  // 数据区
  data() {
    return {
      currentIndex: 0,
      currentIndexjy: 0,
      currentIndexxz: 0,
      currentIndexgd: 0,
      total: 0,
      pageNum: 1,
      pageSize: 8,
      recruitNotice: {
        category: "", // 类别(政企招聘 校园招聘 高端猎聘)
        pcShow: 1, // 是否展示0-否 1-是
      },
      postName: "",
      recruitNoticeList: [],
      dictList: [],
      middleImageList: [],
      reNature: [],
      reExperience: [],
      recruitEducation: [],
      reScale: [],
      reFinancing: [],
      categoryIs: [],
      postNameIs: [],
      // 薪资查询参数
      compensation: [],
      // 是否报名
      userSignup: [
        {
          value: "0",
          label: "已结束",
        },
        {
          value: "1",
          label: "报名中",
        },
      ],
      // 日期查询参数
      signTime: [],
      dataList: [],
      dictType: "",
      queryParams: {
        userSignup: "",
        compensation: "",
        nature: "",
        experience: "",
        degree: "",
        natureUnit: "",
        scale: "",
        financing: "",
        territory: "",
        positionCategory: "",
        seacherButton: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  // 页面加载的时候调用
  created() {
    if (this.$route.query.category) {
      this.recruitNotice.category = this.$route.query.category;
    }
    this.getRecruitNoticeList();
    this.getMiddleList();
    this.getReNature();
    this.getReExperience();
    this.getRecruitEducation();
    this.getReScale(), this.getReFinancing(), this.getNoticeByMajorCategory();
    this.getNoticeBySysPost();
  },
  // 监听器
  watch: {
    // 路由
    $route() {
      if (this.$route.query.category) {
        this.recruitNotice.category = this.$route.query.category;
      }
      this.getRecruitNoticeList();
    },
  },
  methods: {
    // 大查询
    getRecruitNoticeList() {
      let _this = this;
      if (this.signTime && this.signTime.length > 0) {
        this.queryParams.startTime = this.signTime[0];
        this.queryParams.endTime = this.signTime[1];
      } else {
        this.queryParams.startTime = null;
        this.queryParams.endTime = null;
      }
      let parmas = {
        ..._this.recruitNotice,
        ..._this.queryParams,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize,
      };
      // 判断传递的值是否为空
      for (let key in parmas) {
        if (!parmas[key]) {
          delete parmas[key];
        } else if (
          typeof parmas[key] === "string" &&
          parmas[key].trim() === ""
        ) {
          delete parmas[key];
        }
      }
      _this.$api.recruitNotice
        .getRecruitNoticeList(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.recruitNoticeList = res.rows;
            if (this.dictList.length > 0) {
              this.handleData();
            } else {
              this.getByDicType();
            }
            _this.total = Number(res.total);
          }
        })
        .catch(() => {});
    },

    handlerIndex(val) {
      this.currentIndex = val;
    },
    handlerjy(val) {
      this.currentIndexjy = val;
    },
    handlerxz(val) {
      this.currentIndexxz = val;
    },
    handlergd(val) {
      this.currentIndexgd = val;
    },
    getReNature() {
      this.$api.recruitNotice.getReNature().then((response) => {
        // console.log("reNatures----------", JSON.stringify(response));
        for (let i = 0; i <= response.data.length; i++) {
          this.reNature.push({
            dictSort: response.data[i].dictSort,
            dictLabel: response.data[i].dictLabel,
          });
        }
      });
    },
    getReExperience() {
      this.$api.recruitNotice.getReExperience().then((response) => {
        const reExperiences = [];
        response.data.forEach((item) => {
          reExperiences.push(item.dictLabel);
        });
        this.reExperience = reExperiences;
      });
    },
    getRecruitEducation() {
      this.$api.recruitNotice.getRecruitEducation().then((response) => {
        const recruitEducations = [];
        response.data.forEach((item) => {
          recruitEducations.push(item.dictLabel);
        });
        this.recruitEducation = recruitEducations;
      });
    },
    getReScale() {
      this.$api.recruitNotice.getReScale().then((response) => {
        const reScales = [];
        response.data.forEach((item) => {
          reScales.push(item.dictLabel);
        });
        this.reScale = reScales;
      });
    },
    getReFinancing() {
      this.$api.recruitNotice.getReFinancing().then((response) => {
        const reFinancinges = [];
        response.data.forEach((item) => {
          reFinancinges.push(item.dictLabel);
        });
        this.reFinancing = reFinancinges;
      });
    },
    getNoticeByMajorCategory() {
      this.$api.recruitNotice.getNoticeByMajorCategory().then((response) => {
        const categories = [];
        response.data.forEach((item) => {
          categories.push(item.majorCategory);
        });
        this.categoryIs = categories;
      });
    },
    getNoticeBySysPost() {
      this.$api.recruitNotice.getNoticeBySysPost().then((response) => {
        const postNames = [];
        response.data.forEach((item) => {
          postNames.push(item.postName);
        });
        this.postNameIs = postNames;
      });
    },
    getByDicType() {
      let _this = this;
      let param = {
        dictType: "re_notice_status",
      };
      _this.$api.system
        .getDicByCode(param)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            this.dictList = res.data;
            this.handleData();
          }
        })
        .catch(() => {});
    },
    handleData() {
      let _this = this;
      _this.recruitNoticeList.forEach((item) => {
        _this.dictList.forEach((dic) => {
          if (dic.dictValue == item.status) {
            _this.$set(item, "statusName", dic.dictLabel);
          }
        });
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getRecruitNoticeList();
    },
    goTo(id, status) {
      // if (status == 1 || status == 0) {
      this.$router.push({ path: "/recruitDetail", query: { id: id } });
      // }
    },
    searchByPost() {
      let _this = this;
      let param = {
        postName: _this.postName,
        category: _this.recruitNotice.category,
      };
      _this.$api.recruitNotice
        .getNoticeByPostName(param)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.recruitNoticeList = res.rows;
            _this.total = Number(res.total);
          }
        })
        .catch(() => {});
    },
    getMiddleList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 8,
        advZoneId: 3,
        status: 1,
      };
      _this.$api.advertisement
        .list(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.middleImageList = res.rows;
          }
        })
        .catch(() => {});
    },
    goDetail(item) {
      console.log("item", item);
      let _this = this;
      if (item.sourceType == 3) {
        _this.$router.push({
          path: "/newsDetail",
          query: { id: item.linkUrl },
        });
      } else if (item.sourceType == 2) {
        _this.$router.push({
          path: "/recruitDetail",
          query: { id: item.linkUrl },
        });
      } else if (item.sourceType == 1) {
        window.open(item.linkUrl, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.el-divider__text.is-center {
  background-color: unset;
  font-size: 20px;
}

.body-container {
  width: 100%;
  background-color: rgba(164, 171, 189, 0.16);
}

.body-container .body-box {
  max-width: 1200px;
  margin: 0 auto;
}

.body-container .body-box .search {
  display: flex;
  justify-content: center;
  position: relative;
  padding: 24px 0px;
}

.body-container .body-box .search input {
  width: 464px;
  height: 72px;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(64, 112, 179);
  padding: 10px;
}

.body-container .body-box .search button {
  width: 96px;
  height: 72px;
  background: rgb(64, 112, 179);
  border-radius: 0px 8px 8px 0px;
  color: rgb(255, 255, 255);
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 8px;
}

.body-container .body-box .chooes-box {
  width: 100%;
  background-color: #fff;
  padding: 16px;
}

.body-container .body-box .chooes-box .xz-box {
  height: 56px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
}

.body-container .body-box .chooes-box .xz-box .more-item {
  width: 150px;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  /* box-sizing: border-box; */
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 16px;
  text-align: center;
  background: rgb(255, 255, 255);
  /* border: 1px solid rgb(164, 171, 189); */
  margin-right: 10px;
}

.body-container .body-box .chooes-box .xz-box .more-item.active {
  /* border: 2px solid rgb(64, 112, 179); */
  /* border-radius: 8px; */
  background: rgba(64, 112, 179, 0.1);
  color: rgb(64, 112, 179);
  font-size: 16px;
  text-align: center;
}

.body-container .body-box .chooes-box .xz-box .xz-item {
  width: 8%;
  cursor: pointer;
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
}

.body-container .body-box .chooes-box .xz-box .xz-item.active {
  border: 2px solid rgb(64, 112, 179);
  border-radius: 8px;
  height: 36px;
  line-height: 36px;
  background: rgba(64, 112, 179, 0.1);
  color: rgb(64, 112, 179);
  font-size: 16px;
  text-align: center;
}

.body-container .body-box .chooes-box .xz-box div:nth-child(1) {
  font-weight: 600;
}

.body-container .body-box .search-res {
  max-width: 1200px;
  margin: 24px auto 0px;
  display: flex;
  justify-content: space-between;
}

.body-container .body-box .search-res .left-box {
  width: 79%;
}

.body-container .body-box .search-res .left-box .res-item {
  background-color: #fff;
  padding: 18px 16px;
  margin-bottom: 24px;
}

.body-container .body-box .search-res .left-box .pages {
  text-align: center;
  margin: 50px auto;
}

.body-container .body-box .search-res .left-box .res-item .top-res {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px 20px;
}

.body-container .body-box .search-res .left-box .res-item .top-res .title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.body-container .body-box .search-res .left-box .res-item .top-res .date {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
}

.body-container .body-box .search-res .left-box .res-item .top-res .type {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
}

.body-container .body-box .search-res .left-box .res-item .top-res .button {
  width: 144px;
  height: 40px;
  background: rgb(64, 112, 179);
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: rgb(255, 255, 255);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.body-container
  .body-box
  .search-res
  .left-box
  .res-item
  .top-res
  .button-over {
  width: 144px;
  height: 40px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(164, 171, 189);
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.body-container .body-box .search-res .left-box .res-item .top-res .type span {
  font-size: 24px;
  color: rgb(64, 112, 179);
}

.body-container .body-box .search-res .right-box {
  width: 20%;
}

.body-container .body-box .search-res .right-box img {
  width: 240px;
  height: 220px;
  margin-bottom: 24px;
  cursor: pointer;
  min-height: 200px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/view/recruitNotice/recruitList.vue